module.exports = __webpack_public_path__ + "img/so_logo.bf1fe60e.svg";